// Dependency-free so contexts/utils can import these without pulling the
// PassengersData component (which itself imports SelectedResultContext —
// importing the constants from there created a circular init crash).
export const PASSENGER_KEYS = {
  FIRSTNAME: "firstname",
  LASTNAME: "lastname",
  CELL: "cell",
  EMAIL: "email",
  AGE: "age",
  KIS_SEARCH_AGE: "kisSearchAge",
  TITLE: "title",
  GENDER: "gender",
  // IS_KID: 'isKid'
};

export const ROOM_KEYS = {
  LDS_DEAL_ID: "ldsDealId",
  DEAL_FARE: "dealFare",
  OUR_FARE_DETAILS: "ourFareDetails",
  ROOM_SET: "roomSet",
  ROOM_TYPE: "roomType",
  SEQ_NUM: "@seqNum",
};
